import { FC } from 'react';
import classNames from 'classnames';
import { useSelector } from 'react-redux';

import { useTHelper } from 'src/utils/i18n';
import { BaseSeparateModal } from 'src/models/modals';
import { UiModal } from 'src/components/UI/modal/UiModal';
import { PlusSubscriptionUnlimitedFeatureIcon } from 'src/components/plusSubscription/modals/icons/UnlimitedFeature';
import { UiButton } from 'src/components/UI/Button';
import { PlusSubscriptionUpgradeNowModalClose } from 'src/components/plusSubscription/modals/icons/Close';
import { PlusSubscriptionLogoUnlimited } from 'src/components/plusSubscription/modals/icons/LogoUnlimited';
import { UpsellLoadUpdatePricingDialogResponseType } from 'src/models/plusSubscription';
import { PlusSubscriptionModalAdditionalParamsSelector } from 'src/store/plusSubscription/selectors';
import styles from './styles.module.scss';
import { deCommonCurrentPartnerSelector } from '../../../../store/commonPart/selector';

type Props = BaseSeparateModal;

export const UpsellUnlimitedModal: FC<Props> = ({ onClose }) => {
  const tHelper = useTHelper('upsellModals.unlimited');

  const items = ['keepTheTips', 'auctions', 'livestreaming', 'merch', 'noLimits', 'categories'];

  const { CampaignTerminologySingular } = useSelector(deCommonCurrentPartnerSelector);

  const modalParams = useSelector(PlusSubscriptionModalAdditionalParamsSelector) as
    | UpsellLoadUpdatePricingDialogResponseType
    | undefined;

  return (
    <UiModal
      noFooter
      onHide={onClose}
      modalClassName={styles.modal}
      bodyClassName={classNames({ [styles.noHeader]: !modalParams?.IsHeaderVisible })}
    >
      {modalParams?.IsHeaderVisible ? (
        <div className={styles.header}>
          <button type="button" onClick={onClose} className={styles.close}>
            <PlusSubscriptionUpgradeNowModalClose className={styles.icon} />
          </button>

          <PlusSubscriptionLogoUnlimited className={styles.logo} />
        </div>
      ) : (
        <button type="button" onClick={onClose} className={styles.close}>
          <PlusSubscriptionUpgradeNowModalClose className={styles.icon} />
        </button>
      )}

      <div className={styles.content}>
        <div className={styles.contentHeader}>
          <div className={styles.title}>{tHelper('title')}</div>
          <div className={styles.description}>
            {tHelper('description', { campaignSingularTerminology: CampaignTerminologySingular })}
          </div>
        </div>

        <div className={styles.features}>
          {items.map((item) => (
            <div key={item} className={styles.item}>
              <PlusSubscriptionUnlimitedFeatureIcon className={styles.icon} />
              <div className={styles.caption}>{tHelper(`features.${item}.caption`)}</div>
              <div className={styles.description}>
                {tHelper(`features.${item}.description`, {
                  singular: modalParams?.SupporterTerminology?.Singular.toLowerCase(),
                  plural: modalParams?.SupporterTerminology?.Plural.toLowerCase(),
                  projectArticle: modalParams?.ProjectTerminology?.Article.toLowerCase(),
                  projectSingular: modalParams?.ProjectTerminology?.Singular,
                })}
              </div>
            </div>
          ))}
        </div>

        <div className={styles.buttonWrapper}>
          <UiButton onClick={onClose} className={classNames(styles.button, styles.isUnlimited)}>
            {tHelper('gotIt')}
          </UiButton>
        </div>
      </div>
    </UiModal>
  );
};
